// extracted by mini-css-extract-plugin
export default {"container":"loading_screen_container__6GAaW","text_container":"loading_screen_text_container__Q-jEL","icon":"loading_screen_icon__a8jWD","spin":"loading_screen_spin__lFLfq"};